import {
  getProduct,
  getProductTitle,
  getDescription,
  getThemeColor,
  getFavicon32,
  getAppleTouchIcon,
} from './config';

const ensureMeta = (name) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  return el;
};

const ensureLink = (rel, extra = {}) => {
  let selector = `link[rel="${rel}"]`;
  if (extra.type) {
    selector += `[type="${extra.type}"]`;
  }

  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    Object.entries(extra).forEach(([key, value]) => {
      el.setAttribute(key, value);
    });
    document.head.appendChild(el);
  }
  return el;
};

export const applyBranding = () => {
  const product = getProduct();

  document.body.classList.remove('theme-club1', 'theme-course1');
  document.body.classList.add(product === 'course1' ? 'theme-course1' : 'theme-club1');

  document.title = getProductTitle();

  ensureMeta('description').setAttribute('content', getDescription());
  ensureMeta('theme-color').setAttribute('content', getThemeColor());

  ensureLink('apple-touch-icon').setAttribute('href', getAppleTouchIcon());

  const favicon = ensureLink('icon', { type: 'image/png', sizes: '32x32' });
  favicon.setAttribute('href', getFavicon32());
};